import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {AppInsightsService} from "./core/services/application-insights.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet],
})
export class AppComponent {

    constructor(private _appInsightsService: AppInsightsService) {
    }
}
